import { Legal } from "../../views/Legal/Legal";

export const legalRoutes = [
  {
    path: "/legal",
    name: "Legal",
    element: <Legal />,
  },
];
